import styled from 'styled-components';

import { theme } from '@frontend/legacy-components/src/theme/theme';

export const hasFooter = (footerOptions, paginationOptions) => {
  return (
    footerOptions.leftComponent != null ||
    footerOptions.rightComponent != null ||
    footerOptions.customFooter != null ||
    paginationOptions.itemsPerPage != null
  );
};

/**
 * FOOTER BLOCK: Optional auto-generated footer section of the table.
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/legacy-components' instead.
 */
const FooterBlock = ({
  leftComponent,
  rightComponent,
  paginationComponent,
}) => (
  <FooterBlockWrapper>
    <span className={'leftSide'}>{leftComponent}</span>
    <span className={'rightSide'}>
      {rightComponent}
      {paginationComponent}
    </span>
  </FooterBlockWrapper>
);
const FooterBlockWrapper = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.page.surface};
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  color: ${(props) => props.theme.colors.feature.primary};
  display: flex;
  flex-direction: row;
  font-family: ${(props) => props.theme.fonts.default};
  font-size: ${(props) => props.theme.fontSizes.md};
  font-weight: ${(props) => props.theme.fontWeights.default};
  justify-content: space-between;
  line-height: ${(props) => props.theme.lineHeights.md};
  padding: 0.5rem 0.75rem;

  .rightSide .pagination {
    margin-left: 0.75rem;
    margin-right: -0.25rem;
  }

  .rightSide,
  .leftSide {
    display: flex;
    flex-direction: row;
  }
`;
FooterBlockWrapper.defaultProps = { theme };

export default FooterBlock;
